var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__areyas12bfdryeye",
    d: "M4 7.78L1.22 5 0.273 5.94 4 9.667 12 1.667 11.06 0.727z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b1239567fdbdnbQWEWQaa",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__areyas12bfdryeye"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#prefix__b1239567fdbdnbQWEWQaa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H33.333V33.333H0z",
    transform: "translate(-10.667 -11.667)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-check.3e9c200a.svg";
export { ForwardRef as ReactComponent };